const MIME_TYPES_BY_EXTENSION = {
  msg: "application/vnd.ms-outlook",
  eml: "message/rfc822",
  pdf: "application/pdf",
  doc: "application/msword",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  xls: "application/vnd.ms-excel",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  csv: "text/csv",
  txt: "text/plain",
  rtf: "application/rtf",
  zip: "application/zip",
  rar: "application/x-rar-compressed",
  "7z": "application/x-7z-compressed",
  tar: "application/x-tar",
  gz: "application/gzip",
  png: "image/png",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  gif: "image/gif",
  bmp: "image/bmp",
  webp: "image/webp",
  svg: "image/svg+xml",
  tif: "image/tiff",
  tiff: "image/tiff",
  json: "application/json",
  xml: "application/xml",
};

/**
 * Returns the resolved MIME type for a File object, document object, or filename.
 * Special handling for Outlook (.msg) files where browsers don't provide a MIME type.
 *
 * @param {File|Blob|string|{name?: string, type?: string}} file
 * @returns {string}
 */
export const getFileMimeType = (file) => {
  const fileName = typeof file === "string" ? file : file?.name || "";
  const ext = fileName.includes(".")
    ? fileName.slice(fileName.lastIndexOf(".") + 1).toLowerCase()
    : "";

  // Microsoft Outlook .msg files: browsers return empty string or generic octet-stream for file.type.
  // Standard IANA MIME type for Outlook items is application/vnd.ms-outlook.
  if (ext === "msg") {
    return "application/vnd.ms-outlook";
  }

  if (file && typeof file === "object" && file.type && file.type.trim() !== "") {
    return file.type.trim();
  }

  return MIME_TYPES_BY_EXTENSION[ext] || "";
};

export default getFileMimeType;

